<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.new')" :icon="'mdi-plus'" :color="'quaternary'"
    :disabled="false" :outlined="false" :textbtn="textbtn" :large="large" :small="small" @Press="action">
    <!-- Currently only enabled on customer/users and users/customerusers -->
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewAccountBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      this.$store.state.triggerevents.newAccountDialogTrigger++;
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>
